export enum CaseCommonTexts {
  attachmentTypePhoto = 'PHOTO',
  attachmentTypeInvoice = 'INVOICE',
  attachmentTypePass = 'PASS',
  attachmentTypeTicket = 'TICKET',
  attachmentTypePIR = 'PIR',
}

export enum BADetails {
  damageTypeLOSS = 'LOSS',
  damageTypeDELAY = 'DELAY',
  damageTypeTHEFT = 'THEFT',
}
